import { createContext, useContext } from 'react'

/**
 * The four service areas of the design system. A page (or a block inside it)
 * sets `data-service` to one of these; `text-service` / `bg-service-tint` and
 * the @nt/ui `service` chip tone then wear that service's accent.
 */
export type ServiceArea = 'formation' | 'federal-tax' | 'accounting' | 'dissolution'

/** The area's name, for an eyebrow chip or a screen-reader label beside its dot. */
export const SERVICE_AREA_LABEL: Record<ServiceArea, string> = {
  formation: 'Formation',
  'federal-tax': 'Federal tax',
  accounting: 'Accounting',
  dissolution: 'Dissolution',
}

/**
 * The area a `CustomerPageWrapper service` puts in force, so the page's
 * `PageHeader` can show the service dot without the page naming it twice.
 */
export const ServiceAreaContext = createContext<ServiceArea | undefined>(undefined)

export function useServiceArea(): ServiceArea | undefined {
  return useContext(ServiceAreaContext)
}
